import { render } from "./home-view.vue?vue&type=template&id=48742fa5&scoped=true"
import script from "./home-view.vue?vue&type=script&lang=js"
export * from "./home-view.vue?vue&type=script&lang=js"

import "./home-view.vue?vue&type=style&index=0&id=48742fa5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48742fa5"]])

export default __exports__